import React, {Component} from 'react';
import { ColoredButton } from 'packages/components';
import Translator from '../../requests/apa/Translator';
import './styles.css';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import {
    UpdateCardFromRibbonUserObserver
  } from '../../components/PersistentMiniEpg/MiniObserver'
import Utils from '../../utils/Utils';

class RecordingProgressBar extends Component{
    constructor(props){
        super(props);
        this.state = {
            total: ChannelSingleton.getMaxNpvrStorage(),
            used: (props.ribbonRecordings && props.ribbonRecordings.item) ? props.ribbonRecordings.items[0].used : 0,
            updatedByApis: false
        };
        this.showRecordingSpaceOffer = false;
        this.mainText = Translator.get('myContent_recordingSpace_available_label','"Disponible para grabar en tu cuenta:')
        this.usedText = Translator.get('myContent_recordingSpace_used_label','Usado');
        this.freeText = Translator.get('myContent_recordingSpace_free_label','Libre');
        this.h_de = Translator.get('myContent_recordingSpace_from_label', 'h de');
        this.h = Translator.get('myContent_recordingSpace_to_label', 'h');
        this.wantMoreText = Translator.get('myContent_recordingSpace_offer_label','¿Deseas más horas de grabación?');
        this.obtainMoreText = Translator.get('myContent_recordingSpace_option_button_offer','OBTENER');
        this.onFocus = this.onFocus.bind(this);
        document.addEventListener('focus-recordings',this.onFocus);

        this.updateTimeOnDeleteCard = this.updateTimeOnDeleteCard.bind(this);
        this.packages = {}; // objeto para guardar el tiempo usado por cada paquete 
    }

    updateTimeOnDeleteCard(data) {
        if(Utils.isNotNullOrNotUndefined(data) && Utils.isNotNullOrNotUndefined(data.card) && Utils.isNotNullOrNotUndefined(data.card.type) && data.card.type === 'recordings') {
            data = data.card;
            if(data.date_begin && data.date_end) {
                let duration = parseInt(data.date_end - data.date_begin); // seconds
                const currentTimeUsed = isNaN(this.state.used) ? 0 : this.state.used;
                let used = parseInt(currentTimeUsed) - parseInt(duration);
                if(used > (this.state.total * 60)){
                    used = this.state.total * 60;
                } 
                if(data.packId){
                    this.packages[data.packId] = {
                        used,
                        total: this.state.total
                    }
                }
                this.setState({
                    used
                });
            }
        }
    }


    onFocus(event) {
        let used, total;
        if(event && event.detail && event.detail.packId && this.packages[event.detail.packId] && this.packages[event.detail.packId].used){
            used = this.packages[event.detail.packId].used;
        }
        else{
            used = event.detail.time_used;
        }
        if(event && event.detail && event.detail.packId && this.packages[event.detail.packId] && this.packages[event.detail.packId].total){
            total = this.packages[event.detail.packId].total;
        }
        else{
            total = event.detail.time_limit;
        }
        this.setState({
            used,
            total
        });
    }

    componentWillUnmount(){
        document.removeEventListener('update_recording_progress_bar',this.onFocus);
        UpdateCardFromRibbonUserObserver.unsubscribe(this.updateTimeOnDeleteCard);
    }

    componentDidMount(){
        document.addEventListener('update_recording_progress_bar', this.onFocus);
        UpdateCardFromRibbonUserObserver.subscribe(this.updateTimeOnDeleteCard);
        this.updateInitStorage(this.props);
    }
    
    componentWillReceiveProps=(nextProps)=>{
        this.updateInitStorage(nextProps)
    }

    updateInitStorage = (props) => {
        const { items = [] } = (props && props.ribbonRecordings) || {};
        if (items && Array.isArray(items) && items.length > 0) {
            const [firstElement = null] = items;
            if (firstElement && typeof firstElement === 'object') {
                const { used = 0, limit = 0, packId = null, group_id = null } = firstElement;
                this.onFocus({
                    detail: {
                        time_used: used,
                        time_limit: limit || ChannelSingleton.getNpvrStorage(group_id),
                        packId: packId,
                    },
                });
            }
        }
    };

    render(){
        const used = Number.parseFloat(this.state.used / (60*60)).toFixed(1);
        const total = this.state.total < (used * 60) ? used : Number.parseFloat(this.state.total / (60)).toFixed(1);
        this.percentage = parseFloat(100 * used / total);
    
        return (
            <div className='recording-info'>
                <div className="recording-left-side">
                    {`${this.mainText} ${(total-used).toFixed(1)} ${this.h_de} ${total} ${this.h}`}
                    <div className="recording-progress-bar-container">
                        <div className="recording-progress-bar" style={(typeof this.percentage === 'number') && Number(this.percentage) >= 0 && Number(this.percentage) <= 100 ? {width: this.percentage + '%'} : {}}></div>
                    </div>
                    <div className="recording-description">
                        <div className="recording-percentage-color">
                            <div className="used square"/>
                            <div className="recording-percentage-text">
                                {this.usedText}
                            </div>
                        </div>
                        <div className="recording-total-color">
                            <div className="free square"/>
                            <div className="recording-total-text">
                                {this.freeText}
                            </div>
                        </div>
                    </div>
                </div>
                {this.showRecordingSpaceOffer &&
                    <div className="recording-right-side">
                        <div className="recording-want-more-text">
                            {this.wantMoreText}
                        </div>
                        <ColoredButton
                        onClick={this.handleClick}
                        children = {this.obtainMoreText}
                        color="blue"
                        />
                    </div>
                }
            </div>
        );
    }
}

export default RecordingProgressBar;



// WEBPACK FOOTER //
// ./src/components/RecordingProgressBar/index.jsx